// Cart
import '//www.andrayswim.com/cdn/shop/t/36/assets/m-cart.js?v=107839224660067441501784798354';

// # Map storage for better performance
const cartDetailsState = new Map();

// # Single event delegation with capture phase
document.addEventListener("toggle", (event) => {
	const target = event.target;
	if (target.matches("[data-ajax-cart-section] [data-ajax-cart-details]")) {
		const key = target.getAttribute("data-ajax-cart-details");
		if (key) cartDetailsState.set(key, target.open);
	}
}, true);

// # init and section updates
function initCartDetails() {
	for (const $details of document.querySelectorAll("[data-ajax-cart-section] [data-ajax-cart-details]")) {
		const key = $details.getAttribute("data-ajax-cart-details");
		if (key) cartDetailsState.set(key, $details.hasAttribute("open"));
	}
}

document.addEventListener("liquid-ajax-cart:init", initCartDetails);

// #
// # Defensive cart-drawer refresh
// #
// The site owner reported quick-buy adds "taking very very long to show up
// in cart" - reproduced as: adding item A shows the drawer correctly, but
// then adding item B on the same collection page opens a drawer that still
// only shows item A, even though /cart.js confirms both A and B are really
// in the cart. The drawer's visible HTML lags one step behind the true
// cart state - it's a stale-content bug, not a network-speed problem.
//
// The theme's own Section Rendering API hook for this drawer is broken:
// snippets/header-cart.liquid stamps a data-section-id attribute (driven by
// the ambient section.id) onto #cartBox, but header-cart is rendered
// unconditionally from snippets/global-js.liquid, which is itself rendered
// directly from layout/theme.liquid - outside of any section-rendering
// Liquid tag/context. There is no ambient section object available there,
// so that id resolves to an empty string (confirmed live: #cartBox has
// data-section-id=""). Whatever internal section-cache/refresh logic the
// vendored liquid-ajax-cart library (m-cart.js) uses to decide what to
// re-fetch for this element has no valid id to key off, which lines up
// exactly with the "shows the previous item" symptom.
//
// Because of that, we can't ask Shopify's normal Section Rendering API
// (?sections=/?section_id=) for just this drawer - there is no registered
// section id that renders it, and even a normally-valid id (e.g. the
// header section) would return HTML that doesn't include the drawer at
// all. The one thing we know for certain renders the drawer correctly is a
// full, fresh page load (that's exactly how the bug was confirmed in the
// first place: reloading /cart directly showed the true state). So as a
// defensive measure we re-fetch the CURRENT page ourselves, cache-busted,
// and lift the freshly-rendered #cartBox markup out of that response,
// swapping it into the live drawer before opening it. This is independent
// of - and does not replace - whatever the vendor library does internally;
// it's a belt-and-suspenders correction layer.
let cartDrawerRefreshToken = 0;

async function refreshCartDrawerContent(cartBox) {
	const liveMain = cartBox.querySelector("main");
	if (!liveMain) throw new Error("c-cart.js: cart drawer <main> region not found, skipping defensive refresh");

	// Guard against out-of-order responses: if two quick-buy adds fire in
	// quick succession, each schedules its own refresh; only the most
	// recently-started one should ever be allowed to write into the DOM, so
	// a slower earlier response can never clobber a faster, newer one.
	const myToken = ++cartDrawerRefreshToken;

	const url = new URL(window.location.href);
	url.searchParams.set("_", Date.now().toString());

	let response;
	try {
		response = await fetch(url.toString(), {
			method: "GET",
			cache: "no-store",
			credentials: "same-origin",
			headers: { "X-Requested-With": "XMLHttpRequest" },
		});
	} catch (networkError) {
		throw new Error(`c-cart.js: defensive cart drawer refresh network error: ${networkError.message}`);
	}

	if (!response.ok) {
		throw new Error(`c-cart.js: defensive cart drawer refresh got HTTP ${response.status}`);
	}

	const html = await response.text();

	// Another, newer refresh started (and possibly already finished) while
	// we were fetching/parsing this one - drop this stale result rather than
	// risk clobbering more current content with older content.
	if (myToken !== cartDrawerRefreshToken) return false;

	const freshDoc = new DOMParser().parseFromString(html, "text/html");
	const freshBox = freshDoc.getElementById("cartBox");
	const freshMain = freshBox ? freshBox.querySelector("main") : null;

	if (!freshMain) throw new Error("c-cart.js: defensive cart drawer refresh found no #cartBox main markup in response");

	if (myToken !== cartDrawerRefreshToken) return false;

	// Preserve open/closed <details> state (discount code / notes panels)
	// across the swap, mirroring the library's own restore logic below.
	const detailsState = new Map();
	for (const $details of liveMain.querySelectorAll("[data-ajax-cart-details]")) {
		const key = $details.getAttribute("data-ajax-cart-details");
		if (key) detailsState.set(key, $details.open);
	}

	liveMain.innerHTML = freshMain.innerHTML;

	for (const $details of liveMain.querySelectorAll("[data-ajax-cart-details]")) {
		const key = $details.getAttribute("data-ajax-cart-details");
		if (key && detailsState.has(key)) $details.open = detailsState.get(key);
	}

	return true;
}

document.addEventListener("liquid-ajax-cart:request-end", (event) => {
	const { requestState, sections } = event.detail;

	// # Handle successful add to cart
	if (requestState.requestType === "add" && requestState.responseData?.ok) {
		const formElement = requestState.info.initiator?.closest('ajax-cart-product-form');
		const cartType = formElement?.getAttribute('cart-type') || 'drawer';
		
		if (cartType === 'redirect') {
			window.location.href = window.routes?.cart_url || '/cart';
		} else if (window.location.pathname === '/cart') {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		} else {
			const cartBox = document.getElementById("cartBox");
			if (cartBox) {
				// Best-effort defensive refresh before opening. Never let this
				// block the drawer open for more than ~2s, and never let a
				// failure leave the drawer worse off than the old (pre-fix)
				// behavior - on any error/timeout we simply fall back to
				// opening with whatever the vendor library already rendered.
				// Note this does not delay or otherwise touch the add-to-cart
				// request itself, which has already completed successfully by
				// the time this event fires - only the drawer's visual open is
				// (briefly, and boundedly) deferred to guarantee it reflects
				// the true cart contents.
				const refreshPromise = refreshCartDrawerContent(cartBox).catch((err) => {
					console.warn("[c-cart] Defensive cart drawer refresh skipped:", err);
					return false;
				});
				const timeoutPromise = new Promise((resolve) => setTimeout(() => resolve(false), 2000));
				Promise.race([refreshPromise, timeoutPromise]).finally(() => cartBox.open());
			}
		}
		
		document.body.setAttribute("cart-state", "done");
		setTimeout(() => document.body.removeAttribute("cart-state"), 4000);
	}

	// # Restore details state only on actual section re-renders
	if (sections?.length && requestState.info.initiator !== "mutation") {
		for (const { elements } of sections) {
			for (const element of elements) {
				for (const $details of element.querySelectorAll("[data-ajax-cart-details]")) {
					const key = $details.getAttribute("data-ajax-cart-details");
					if (key && cartDetailsState.has(key)) {
						$details.open = cartDetailsState.get(key);
					}
				}
			}
		}
	}
});

// Remove in production
window.liquidAjaxCart.conf('updateOnWindowFocus', false);
